import { IonHeader, IonPage, IonSpinner, IonTitle } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/back-button";
import { Buttons } from "@/components/buttons";
import { Content } from "@/components/content";
import { Toolbar } from "@/components/toolbar";
import { useOrganization } from "@/lib/backend/utils/hooks/use-organization";
import { Routes } from "@/lib/router";

export function TermsPage() {
  const { t } = useTranslation();
  const { data: organization, isLoading } = useOrganization();

  const termsContent = organization?.termsAndConditions;

  return (
    <IonPage>
      <IonHeader>
        <Toolbar>
          <Buttons slot="secondary">
            <BackButton defaultHref={Routes.Settings()} />
          </Buttons>
          <IonTitle>{t("routes:terms.title")}</IonTitle>
        </Toolbar>
      </IonHeader>

      <Content scrollUnderChrome className="part-scroll:gap-6">
        <div className="space-y-6 px-4 py-6">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <IonSpinner />
            </div>
          ) : termsContent ? (
            <div
              className="prose prose-sm prose-headings:text-txt-primary prose-strong:text-txt-primary max-w-none text-txt-secondary"
              dangerouslySetInnerHTML={{ __html: termsContent }}
            />
          ) : (
            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-txt-primary">
                Algemene voorwaarden niet beschikbaar
              </h2>
              <p className="text-txt-secondary">
                De algemene voorwaarden voor deze organisatie zijn momenteel niet beschikbaar. Neem
                contact op met de organisatie voor meer informatie.
              </p>
            </div>
          )}
        </div>
      </Content>
    </IonPage>
  );
}
